import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import { getUser, clearMessage, messageUser } from "../../../_actions/user_actions";
import { Formik } from 'formik';
import { Form, Input, Button, Row, Col, message, Card, Tooltip } from 'antd';
import dayjs from 'dayjs'; //for formatting date and time, used to add timestamp to message
import './User.css';

const formItemLayout = {
  labelCol: {
    xs: { span: 44 },
    sm: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 13 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 10,
    },
    sm: {
      span: 16,
      offset: 10,
    },
  },
};

function UserPage(props) {
  const zeroValue = "0001-01-01T00:00:00Z";
  const dispatch = useDispatch();
  const chosenUser = props.data.user.chosenUser ?? {firstName: "Loading"}

  useEffect(() => {
    const path = props.location.pathname
    let n = path.lastIndexOf('/');
    let short_id = path.substring(n + 1);
    let dataToSubmit = {id : short_id}
  	dispatch(getUser(dataToSubmit))
    // the classes section will be blank until you change the endpoint to take school id and user id, currently it gets the school id from the requester but the sysadmin is not in a school
    // dispatch(getClassMembers(dataToSubmit));
  }, [dispatch, props.location.pathname])

  useEffect(() => {
      if (!props.user.message) return;
      if (props.user.message === "Message Sent") {
        message.success("Message Sent")
      }
      else {
          message.error(props.user.message)
      }
      dispatch(clearMessage())
    }, [props.user.message, dispatch, props.history])
  
  return (
    <Formik
      enableReinitialize
      initialValues={{
        _id: chosenUser._id,
        lastName: chosenUser.lastName,
        firstName: chosenUser.firstName,
        netWorth: chosenUser.netWorth,
        rank: chosenUser.rank,
        children: chosenUser.children,
        college: chosenUser.college,
        income: chosenUser.income,
        changeCareer: chosenUser.careerTransition,
        tax: chosenUser.taxableIncome,
        newJob: chosenUser.collegeEnd !== zeroValue ? chosenUser.collegeEnd : chosenUser.transitionEnd !== zeroValue ? chosenUser.transitionEnd : zeroValue,
        message: ""
      }}

      onSubmit={(values, { setSubmitting }) => {

          let dataToSubmit = {
            user_id: values._id,
            message: dayjs().format('MM-DD-YY HH:mm') + ": " + values.message,
          };

          dispatch(messageUser(dataToSubmit)).then(() => {
            values.message = ""
            setSubmitting(false)
          })
      }}
    >

      {props => {
        const {
          values,
          isSubmitting,
          handleSubmit,
          handleChange,
          handleBlur
        } = props;

        return (
          <div className="body">
            <div className='form'>
              <h1>User Details</h1>
              <Form {...formItemLayout} onSubmit={handleSubmit} >
                <Row>
                  <Col span={8}>
                    <Form.Item label="First Name">
                      <Input
                        readOnly
                        id="firstName"
                        placeholder="Enter your first name"
                        type="text"
                        value={values.firstName}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Last Name">
                      <Input
                        readOnly
                        id="lastName"
                        placeholder="Enter your Last Name"
                        type="text"
                        value={values.lastName}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Email/ID">
                      <Input
                        readOnly
                        id="email"
                        placeholder="Enter your Email"
                        type="email"
                        value={values._id}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>
                    <Form.Item label="Net Worth">
                      <Input
                        readOnly
                        id="netWorth"
                        placeholder="Here is your net worth"
                        type="float"
                        value={values.netWorth}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Rank">
                      <Input
                        readOnly
                        id="rank"
                        placeholder="Enter your Email"
                        type="text"
                        value={values.rank}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Tooltip title="Income since last tax">
                      <Form.Item label="Taxable Income">
                        <Input
                          readOnly
                          id="tax"
                          placeholder="Taxable Income"
                          type="text"
                          value={values.tax}
                        />
                      </Form.Item>
                    </Tooltip>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>
                    <Form.Item label="Income">
                      <Input
                        readOnly
                        id="income"
                        placeholder="Annual Income"
                        type="int"
                        value={values.income}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Change Career">
                      <label className="switch">
                        <span className="slider round"></span>
                      </label>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="University">
                      <label className="switch">
                        <span className="slider round"></span>
                      </label>
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>
                    <Form.Item label="New Job" hasFeedback>
                      <Input
                        readOnly
                        id="newJob"
                        type="text"
                        value={dayjs(values.newJob).format('YYYY-MM-DD HH:mm')}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>
                    <Form.Item label="Message">
                      <Input.TextArea
                        rows={5}
                        id="message"
                        type="text"
                        value={values.message}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {/* <Row>
                  <Col span={8}>
                    <Form.Item label="Classes">
                      <Input.TextArea
                        readOnly
                        id="classes"
                        type="text"
                        value={classesToString(classes)}
                        autoSize={{ minRows: 1, maxRows: 15 }}
                      />
                    </Form.Item>
                  </Col>
                </Row> */}

                {/* right about here I want an input that will allow me to send them a message */}
                <Form.Item {...tailFormItemLayout}>
                  <Button onClick={handleSubmit} type="primary" disabled={isSubmitting || values.message === ""}>
                    Send Message
                  </Button>
                </Form.Item>
                <Row>
                  <Col span={24}>
                    <Card title={chosenUser.job?.title ?? "Loading"} bordered={false}>
                      <p>Median Pay: {chosenUser.job?.pay ?? "Loading"}</p>
                      <p>Description: {chosenUser.job?.description ?? "Loading"}</p>
                    </Card>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        );
      }}
    </Formik>
  );
}

function mapStateToProps(state) {
  return {
    data: state
  };
}

export default withRouter(connect(mapStateToProps)(UserPage))
